﻿import { Component,Input,Output, EventEmitter,ViewChild,HostListener } from "@angular/core";
import { Globals } from "projects/shared/models/Globals";
import { AppService } from "../../services/app.service";
import { GenericResponseContract } from "projects/shared/models/GenericResponseContract";
import { GenericFiltrationContract } from "projects/shared/models/GenericFiltrationContract";
import {  SwiperDirective, SwiperConfigInterface } from 'ngx-swiper-wrapper';

@Component({
  selector: "dynasty-timeline",
  templateUrl: "./dynasty-timeline.component.html",
  styles: []
})
export class DynastyTimelineComponent {

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    event.target.innerWidth;
    this.refineTimeLine();
  }
  
  dynasties:any;

  _periodId;
  get periodId(): number { 
    return this._periodId;
  }
  @Input()
  set periodId(val: number) {
    this._periodId = val;
    if(val)
      this.getTimelineDynasties();
  }

  @Output() dynastiesIds = new EventEmitter();

  public configDynastyTimeline: SwiperConfigInterface = {
          observer: true,
          direction: 'horizontal',
          loop: false,
          pagination:true,
          navigation: true,
          scrollbar: true,
          slidesPerView:6,
          initialSlide:0
  };
 
  @ViewChild(SwiperDirective) directiveRef: SwiperDirective;
  
  constructor(private  apiService:  AppService) { }

  ngOnInit() {}

  getTimelineDynasties(){
    var input = new GenericFiltrationContract(this._periodId, 1, 10);
    this.apiService.getTimelineDynasties(input).subscribe((response:  GenericResponseContract<object>) => {
        this.dynasties  =  response.Data;
        this.resetTimeLineActive();
        this.refineTimeLine();
        console.log(response);
    });    
  }

  sendDynastiesIds(id){
    this.dynastiesIds.emit(id);
  }

  public getLocalizedEra(era){
    let localizedEra:string=Globals.MapLocalizedResources.DateBC;
    if(era=="AD") localizedEra=Globals.MapLocalizedResources.DateAD
  return localizedEra;
}

resetTimeLineActive(){

    setTimeout(() => {
      this.directiveRef.config.speed = 0;
      this.directiveRef.setIndex(0);
      this.directiveRef.update();
      setTimeout(() => {
        this.directiveRef.config.speed = 500;
        this.directiveRef.update();
      }, 150);
    }, 150);

  }

  private refineTimeLine(){

    var slidesCount=6;

    if (window.innerWidth <= 820) {
      slidesCount=1
    } else if (window.innerWidth <= 1024) {
      slidesCount=3    
    } else if (window.innerWidth <= 1280) {
      slidesCount=4  
    } else if (window.innerWidth <= 1366) {
      slidesCount=5    
    } else if (window.innerWidth <= 1600) {
      slidesCount=6   
    } else if (window.innerWidth < 1900) {
      slidesCount=6
    } else if (window.innerWidth >= 1900) {
      slidesCount=6
    }

    this.configDynastyTimeline.slidesPerView=slidesCount;
    this.directiveRef.update();
  }
}
